// source: io/codedrills/proto/user/team.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.io.codedrills.proto.user.CustomAttributeMap', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CustomAttributeValue', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CustomAttributeValue.CustomattributevalueCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Member', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.MemberRole', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.MembershipState', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.Organizations', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.TeamDetails', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.TeamDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.TeamDetails.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.TeamDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.TeamDetails.displayName = 'proto.io.codedrills.proto.user.TeamDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CustomAttributeMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.CustomAttributeMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CustomAttributeMap.displayName = 'proto.io.codedrills.proto.user.CustomAttributeMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Organizations = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.Organizations.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.Organizations, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Organizations.displayName = 'proto.io.codedrills.proto.user.Organizations';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.Member = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.Member, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.Member.displayName = 'proto.io.codedrills.proto.user.Member';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CustomAttributeValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.io.codedrills.proto.user.CustomAttributeValue.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.user.CustomAttributeValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CustomAttributeValue.displayName = 'proto.io.codedrills.proto.user.CustomAttributeValue';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.TeamDetails.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.TeamDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.TeamDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.TeamDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contentId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    membersList: jspb.Message.toObjectList(msg.getMembersList(),
    proto.io.codedrills.proto.user.Member.toObject, includeInstance),
    createdBy: jspb.Message.getFieldWithDefault(msg, 5, ""),
    organizations: (f = msg.getOrganizations()) && proto.io.codedrills.proto.user.Organizations.toObject(includeInstance, f),
    externalId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    customAttribute: (f = msg.getCustomAttribute()) && proto.io.codedrills.proto.user.CustomAttributeMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.TeamDetails}
 */
proto.io.codedrills.proto.user.TeamDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.TeamDetails;
  return proto.io.codedrills.proto.user.TeamDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.TeamDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.TeamDetails}
 */
proto.io.codedrills.proto.user.TeamDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    case 4:
      var value = new proto.io.codedrills.proto.user.Member;
      reader.readMessage(value,proto.io.codedrills.proto.user.Member.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 6:
      var value = new proto.io.codedrills.proto.user.Organizations;
      reader.readMessage(value,proto.io.codedrills.proto.user.Organizations.deserializeBinaryFromReader);
      msg.setOrganizations(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalId(value);
      break;
    case 8:
      var value = new proto.io.codedrills.proto.user.CustomAttributeMap;
      reader.readMessage(value,proto.io.codedrills.proto.user.CustomAttributeMap.deserializeBinaryFromReader);
      msg.setCustomAttribute(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.TeamDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.TeamDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.TeamDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.io.codedrills.proto.user.Member.serializeBinaryToWriter
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOrganizations();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.io.codedrills.proto.user.Organizations.serializeBinaryToWriter
    );
  }
  f = message.getExternalId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCustomAttribute();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.io.codedrills.proto.user.CustomAttributeMap.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.TeamDetails} returns this
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.TeamDetails} returns this
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 content_id = 3;
 * @return {number}
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.TeamDetails} returns this
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated Member members = 4;
 * @return {!Array<!proto.io.codedrills.proto.user.Member>}
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.user.Member>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.user.Member, 4));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.user.Member>} value
 * @return {!proto.io.codedrills.proto.user.TeamDetails} returns this
*/
proto.io.codedrills.proto.user.TeamDetails.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.io.codedrills.proto.user.Member=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.Member}
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.io.codedrills.proto.user.Member, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.TeamDetails} returns this
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};


/**
 * optional string created_by = 5;
 * @return {string}
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.TeamDetails} returns this
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Organizations organizations = 6;
 * @return {?proto.io.codedrills.proto.user.Organizations}
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.getOrganizations = function() {
  return /** @type{?proto.io.codedrills.proto.user.Organizations} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.Organizations, 6));
};


/**
 * @param {?proto.io.codedrills.proto.user.Organizations|undefined} value
 * @return {!proto.io.codedrills.proto.user.TeamDetails} returns this
*/
proto.io.codedrills.proto.user.TeamDetails.prototype.setOrganizations = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.TeamDetails} returns this
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.clearOrganizations = function() {
  return this.setOrganizations(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.hasOrganizations = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string external_id = 7;
 * @return {string}
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.getExternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.TeamDetails} returns this
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.setExternalId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional CustomAttributeMap custom_attribute = 8;
 * @return {?proto.io.codedrills.proto.user.CustomAttributeMap}
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.getCustomAttribute = function() {
  return /** @type{?proto.io.codedrills.proto.user.CustomAttributeMap} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.CustomAttributeMap, 8));
};


/**
 * @param {?proto.io.codedrills.proto.user.CustomAttributeMap|undefined} value
 * @return {!proto.io.codedrills.proto.user.TeamDetails} returns this
*/
proto.io.codedrills.proto.user.TeamDetails.prototype.setCustomAttribute = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.TeamDetails} returns this
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.clearCustomAttribute = function() {
  return this.setCustomAttribute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.TeamDetails.prototype.hasCustomAttribute = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CustomAttributeMap.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CustomAttributeMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CustomAttributeMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CustomAttributeMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    customAttributeMap: (f = msg.getCustomAttributeMap()) ? f.toObject(includeInstance, proto.io.codedrills.proto.user.CustomAttributeValue.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CustomAttributeMap}
 */
proto.io.codedrills.proto.user.CustomAttributeMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CustomAttributeMap;
  return proto.io.codedrills.proto.user.CustomAttributeMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CustomAttributeMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CustomAttributeMap}
 */
proto.io.codedrills.proto.user.CustomAttributeMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getCustomAttributeMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.io.codedrills.proto.user.CustomAttributeValue.deserializeBinaryFromReader, "", new proto.io.codedrills.proto.user.CustomAttributeValue());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CustomAttributeMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CustomAttributeMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CustomAttributeMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CustomAttributeMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomAttributeMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.io.codedrills.proto.user.CustomAttributeValue.serializeBinaryToWriter);
  }
};


/**
 * map<string, CustomAttributeValue> custom_attribute = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.io.codedrills.proto.user.CustomAttributeValue>}
 */
proto.io.codedrills.proto.user.CustomAttributeMap.prototype.getCustomAttributeMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.io.codedrills.proto.user.CustomAttributeValue>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.io.codedrills.proto.user.CustomAttributeValue));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.io.codedrills.proto.user.CustomAttributeMap} returns this
 */
proto.io.codedrills.proto.user.CustomAttributeMap.prototype.clearCustomAttributeMap = function() {
  this.getCustomAttributeMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.Organizations.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Organizations.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Organizations.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Organizations} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Organizations.toObject = function(includeInstance, msg) {
  var f, obj = {
    organizationsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Organizations}
 */
proto.io.codedrills.proto.user.Organizations.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Organizations;
  return proto.io.codedrills.proto.user.Organizations.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Organizations} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Organizations}
 */
proto.io.codedrills.proto.user.Organizations.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addOrganizations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Organizations.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Organizations.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Organizations} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Organizations.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string organizations = 1;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.user.Organizations.prototype.getOrganizationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.user.Organizations} returns this
 */
proto.io.codedrills.proto.user.Organizations.prototype.setOrganizationsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.Organizations} returns this
 */
proto.io.codedrills.proto.user.Organizations.prototype.addOrganizations = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.Organizations} returns this
 */
proto.io.codedrills.proto.user.Organizations.prototype.clearOrganizationsList = function() {
  return this.setOrganizationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.Member.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.Member.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.Member} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Member.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    handle: jspb.Message.getFieldWithDefault(msg, 3, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    membershipState: jspb.Message.getFieldWithDefault(msg, 5, 0),
    memberRole: jspb.Message.getFieldWithDefault(msg, 6, 0),
    customAttribute: (f = msg.getCustomAttribute()) && proto.io.codedrills.proto.user.CustomAttributeMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.Member}
 */
proto.io.codedrills.proto.user.Member.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.Member;
  return proto.io.codedrills.proto.user.Member.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.Member} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.Member}
 */
proto.io.codedrills.proto.user.Member.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHandle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 5:
      var value = /** @type {!proto.io.codedrills.proto.user.MembershipState} */ (reader.readEnum());
      msg.setMembershipState(value);
      break;
    case 6:
      var value = /** @type {!proto.io.codedrills.proto.user.MemberRole} */ (reader.readEnum());
      msg.setMemberRole(value);
      break;
    case 7:
      var value = new proto.io.codedrills.proto.user.CustomAttributeMap;
      reader.readMessage(value,proto.io.codedrills.proto.user.CustomAttributeMap.deserializeBinaryFromReader);
      msg.setCustomAttribute(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.Member.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.Member.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.Member} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.Member.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHandle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMembershipState();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getMemberRole();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getCustomAttribute();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.io.codedrills.proto.user.CustomAttributeMap.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.Member.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Member} returns this
 */
proto.io.codedrills.proto.user.Member.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.Member.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Member} returns this
 */
proto.io.codedrills.proto.user.Member.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string handle = 3;
 * @return {string}
 */
proto.io.codedrills.proto.user.Member.prototype.getHandle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Member} returns this
 */
proto.io.codedrills.proto.user.Member.prototype.setHandle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string user_id = 4;
 * @return {string}
 */
proto.io.codedrills.proto.user.Member.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.Member} returns this
 */
proto.io.codedrills.proto.user.Member.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional MembershipState membership_state = 5;
 * @return {!proto.io.codedrills.proto.user.MembershipState}
 */
proto.io.codedrills.proto.user.Member.prototype.getMembershipState = function() {
  return /** @type {!proto.io.codedrills.proto.user.MembershipState} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.MembershipState} value
 * @return {!proto.io.codedrills.proto.user.Member} returns this
 */
proto.io.codedrills.proto.user.Member.prototype.setMembershipState = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional MemberRole member_role = 6;
 * @return {!proto.io.codedrills.proto.user.MemberRole}
 */
proto.io.codedrills.proto.user.Member.prototype.getMemberRole = function() {
  return /** @type {!proto.io.codedrills.proto.user.MemberRole} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.MemberRole} value
 * @return {!proto.io.codedrills.proto.user.Member} returns this
 */
proto.io.codedrills.proto.user.Member.prototype.setMemberRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional CustomAttributeMap custom_attribute = 7;
 * @return {?proto.io.codedrills.proto.user.CustomAttributeMap}
 */
proto.io.codedrills.proto.user.Member.prototype.getCustomAttribute = function() {
  return /** @type{?proto.io.codedrills.proto.user.CustomAttributeMap} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.user.CustomAttributeMap, 7));
};


/**
 * @param {?proto.io.codedrills.proto.user.CustomAttributeMap|undefined} value
 * @return {!proto.io.codedrills.proto.user.Member} returns this
*/
proto.io.codedrills.proto.user.Member.prototype.setCustomAttribute = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.Member} returns this
 */
proto.io.codedrills.proto.user.Member.prototype.clearCustomAttribute = function() {
  return this.setCustomAttribute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.Member.prototype.hasCustomAttribute = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.user.CustomAttributeValue.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.CustomAttributeValue.CustomattributevalueCase = {
  CUSTOMATTRIBUTEVALUE_NOT_SET: 0,
  STRING_VALUE: 1,
  NUMBER_VALUE: 2
};

/**
 * @return {proto.io.codedrills.proto.user.CustomAttributeValue.CustomattributevalueCase}
 */
proto.io.codedrills.proto.user.CustomAttributeValue.prototype.getCustomattributevalueCase = function() {
  return /** @type {proto.io.codedrills.proto.user.CustomAttributeValue.CustomattributevalueCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.user.CustomAttributeValue.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CustomAttributeValue.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CustomAttributeValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CustomAttributeValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CustomAttributeValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    stringValue: jspb.Message.getFieldWithDefault(msg, 1, ""),
    numberValue: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CustomAttributeValue}
 */
proto.io.codedrills.proto.user.CustomAttributeValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CustomAttributeValue;
  return proto.io.codedrills.proto.user.CustomAttributeValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CustomAttributeValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CustomAttributeValue}
 */
proto.io.codedrills.proto.user.CustomAttributeValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStringValue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNumberValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CustomAttributeValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CustomAttributeValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CustomAttributeValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CustomAttributeValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string string_value = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.CustomAttributeValue.prototype.getStringValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.CustomAttributeValue} returns this
 */
proto.io.codedrills.proto.user.CustomAttributeValue.prototype.setStringValue = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.io.codedrills.proto.user.CustomAttributeValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CustomAttributeValue} returns this
 */
proto.io.codedrills.proto.user.CustomAttributeValue.prototype.clearStringValue = function() {
  return jspb.Message.setOneofField(this, 1, proto.io.codedrills.proto.user.CustomAttributeValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CustomAttributeValue.prototype.hasStringValue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 number_value = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.CustomAttributeValue.prototype.getNumberValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.CustomAttributeValue} returns this
 */
proto.io.codedrills.proto.user.CustomAttributeValue.prototype.setNumberValue = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.io.codedrills.proto.user.CustomAttributeValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CustomAttributeValue} returns this
 */
proto.io.codedrills.proto.user.CustomAttributeValue.prototype.clearNumberValue = function() {
  return jspb.Message.setOneofField(this, 2, proto.io.codedrills.proto.user.CustomAttributeValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CustomAttributeValue.prototype.hasNumberValue = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.MembershipState = {
  MEMBERSHIP_STATE_UNKNOWN: 0,
  MEMBERSHIP_INVITED: 1,
  MEMBERSHIP_ACCEPTED: 2,
  MEMBERSHIP_DECLINED: 3
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.MemberRole = {
  MEMBER_ROLE_UNKNOWN: 0,
  MEMBER_ROLE_MEMBER: 1,
  MEMBER_ROLE_COACH: 2
};

goog.object.extend(exports, proto.io.codedrills.proto.user);
